import React from "react";
import { Form as Formiker, Field, withFormik } from "formik";
import { Input, Search, Button, Icon, } from "semantic-ui-react";
import * as Yup from "yup";
import { connect } from "react-redux";
import { signInFetchData } from "../../redux/actions/userAction";
import { permissions } from "../../redux/actions/permissionAction";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import { consigneeModuleName, consignorModuleName, consigneeConsignorCheck } from '../../utils/constant'
import { LOGIN_ERROR_MESSAGE, USER_NAME_REQUIRED, PASSWORD_REQUIRED, LOGIN_USERNAME_PLACEHOLDER, LOGIN_PASSWORD_PLACEHOLDER } from '../../utils/validationConstant'
const pControl = {
  height: "40px",
  // borderRadius: "10px",
  color: "black",
};

const LoginView = ({ values, errors, touched, isSubmitting }) => (
  <React.Fragment>
    <div className="container">
      <div className="row">
        <div className="col-md-4 col-sm-4 offset-md-4 w3-white w3-card mt-5 w3-round-large">
          <div className="row">
            <div className="col-md-4 col-sm-2 mt-5 offset-md-4">
              <img
                className="img-responsive"
                alt=""
                src="assets/svg/t_a.svg"
                width="60"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-10 col-sm-10 mt-0 offset-md-1">
              <p className="font-weight-bolder titleName text-center w3-text-blue">
                Partner Allocation
              </p>
            </div>
          </div>
          <Formiker>
            <div className="row">
              <div className="col-md-10 offset-md-1 col-sm-10 offset-sm-1">
                <div className="ui form">
                  <Field
                    name="username"
                    className="input fluid ui"
                    style={pControl}
                    type="text"
                    placeholder={LOGIN_USERNAME_PLACEHOLDER}

                  />
                  {touched.username && errors.username && (
                    <div className="red error">{errors.username}</div>
                  )}
                  {/* <span className="erricon" style={erricon}>{this.state.errors ? <span> <i title="invalid Username" className="fas fa-times-circle animated rotateIn"></i> </span> : ""}
                                        {this.state.correct ? <i className="fas fa-check-circle w3-text-blue animated rotateIn"></i> : ''}
                                    </span> */}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-10 offset-md-1 col-sm-10 offset-sm-1 mt-4">
                <div className="ui form  mt-10">
                  <Field
                    name="password"
                    className="input fluid ui"
                    style={pControl}
                    type="password"
                    placeholder={LOGIN_PASSWORD_PLACEHOLDER}
                  />
                  {touched.password && errors.password && (
                    <div className="red error">{errors.password}</div>
                  )}
                  {/* <span className="erricon" style={erricon}>{this.state.errors ? <span> <i title="invalid password" className="fas fa-times-circle animated rotateIn" data-toggle="tooltip" data-placement="right"></i> </span> : ''}
                                        {this.state.correct ? <i className="fas fa-check-circle w3-text-blue animated rotateIn"></i> : ''}
                                    </span> */}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-10 offset-md-1 col-sm-10 offset-sm-1">
                <div className="text-center mt-4  mb-3 ml-5 mr-5">
                  <input
                    className="form-check-input small"
                    type="checkbox"
                    value=""
                    id="invalidCheck"

                  />

                  <label
                    className="form-check-label small"
                    htmlFor="invalidCheck">
                    Remember Me
                  </label>

                  {/* <small> forgot <Link to="#"><b>password & username</b></Link> ?</small> */}
                </div>
                <div className=" mb-5">
                  <Button
                    type="submit"
                    disabled={isSubmitting}
                    className="fluid primary"
                  >
                    <small>Sign In</small>
                  </Button>
                </div>
              </div>
            </div>
          </Formiker>
        </div>
      </div>
    </div>
  </React.Fragment>
);

const FormikLogin = withFormik({
  mapPropsToValues({ username, password }) {
    return {
      username: username || "",
      password: password || "",
    };
  },
  validationSchema: Yup.object().shape({
    username: Yup.string().required(USER_NAME_REQUIRED),
    password: Yup.string().required(PASSWORD_REQUIRED),
  }),
  handleSubmit(values, { setErrors, setSubmitting, props }) {
    let userName = values.username;
    let password = values.password;
    // let module_name = "vendor_app";
    props.signInFetchData(userName, password).then((res) => {
      localStorage.setItem('customerLogo', res.customerLogo);
      localStorage.setItem('branchIds', res.branchIds);
      localStorage.setItem('billingpartbranchIds', res.billingPartyBranchIds);
      localStorage.setItem('billingpartIds', res.billingPartyIds);
      if (res.role === 'Consignee') {
        props.signInFetchData(userName, password, consigneeModuleName).then((res) => {
          localStorage.setItem('consigneeId', res.consigneeId);
        })
      } else if (res.role === 'Consignor') {
        props.signInFetchData(userName, password, consignorModuleName).then((res) => {
          localStorage.setItem('consignorId', res.consignorId);
        })
      }
      if (res && res.customerNo) {
        setTimeout(() => {
          localStorage.getItem('role') == 'Vendor' ? window.location.href = "/active-orders" : consigneeConsignorCheck(res.role) ? window.location.href = "/deliveries" : window.location.href = "/shipment";
        }, 500);
      } else {
        props.errorAlertDispatcher({
          type: "error",
          messageHeader: "Error",
          messageBody: res?.response?.data?.reason ? res.response.data.reason :  LOGIN_ERROR_MESSAGE,
        });
        setSubmitting(false);
      }
    });
  },
})(LoginView);

export default connect(null, {
  signInFetchData,
  permissions,
  successAlertDispatcher,
  errorAlertDispatcher,
})(FormikLogin);
